import { useEffect } from 'react';

// O NOME DA TELA NA ABA DO NAVEGADOR (2026-10-29, "app ultraprofissional"). Antes toda aba dizia
// "APP SOLARIC ENERGIA & INFRAESTRUTURA": com cinco abertas não havia como achar a de Obras, e o
// histórico do navegador era uma lista de linhas iguais.
export const TITULO_PADRAO = 'Solaric Energia & Infraestrutura';

// Telas que não estão no menu lateral, mas merecem nome na aba e no caminho do topo.
const FORA_DO_MENU = [
  ['/notificacoes', 'Notificações'], ['/rdo/', 'Diário de obra (RDO)'], ['/rnc/', 'RNC'],
  ['/rrm/', 'RRM'], ['/checklist/', 'Checklist'], ['/crm', 'CRM'], ['/dashboard-obras', 'Painel de obras'],
  ['/catalogo-servicos', 'Catálogo de serviços'], ['/backup', 'Backup'],
  ['/minha-programacao', 'Minha programação'],
];

export function nomeDaTelaForaDoMenu(caminho) {
  const achado = FORA_DO_MENU.find(([p]) => caminho === p || caminho.startsWith(p.endsWith('/') ? p : `${p}/`));
  return achado ? achado[1] : null;
}

export default function TituloDaAba({ titulo }) {
  useEffect(() => {
    document.title = titulo ? `${titulo} · Solaric` : TITULO_PADRAO;
    return () => { document.title = TITULO_PADRAO; };
  }, [titulo]);
  return null;
}
